import { render, staticRenderFns } from "./EventEntryButton.vue?vue&type=template&id=a3350876&scoped=true"
import script from "./EventEntryButton.vue?vue&type=script&lang=ts"
export * from "./EventEntryButton.vue?vue&type=script&lang=ts"
import style0 from "./EventEntryButton.vue?vue&type=style&index=0&id=a3350876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3350876",
  null
  
)

export default component.exports